import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search as SearchIcon } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export const SearchBar: React.FC<{ dark?: boolean }> = ({ dark }) => {
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const { t } = useI18n();
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (q.trim().length >= 2) navigate(`/search?q=${encodeURIComponent(q.trim())}`);
    else navigate("/search");
  };
  return (
    <form onSubmit={submit} className="relative" data-testid="global-search-form">
      <SearchIcon
        size={15}
        className={`pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 ${dark ? "text-sidebar-muted" : "text-muted-foreground"}`}
      />
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={t("common.search")}
        aria-label={t("common.search_platform")}
        data-testid="global-search-input"
        className={`w-full rounded-md py-1.5 pl-8 pr-2 text-sm outline-none transition-colors ${
          dark
            ? "bg-white/10 text-sidebar-foreground placeholder:text-sidebar-muted focus:bg-white/15"
            : "bg-secondary text-foreground placeholder:text-muted-foreground focus:bg-secondary/80"
        }`}
      />
    </form>
  );
};
